// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__box--YuUGi {
  display: flex;
  flex-direction: row;
  gap: 4px;
  position: relative;
}
.src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__spin--M6HPG {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0.5rem;
}
.src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__error--v811L {
  color: red;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sheet2/components/CellInternalBox/CellInternalBox.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AACF;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AADF;AAGA;EACE,UAAA;EACA,kBAAA;AADF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  position: relative;\n  // height: 100%; Убрал т.к. если в одном ряду TextArea и InputNumber, то InputNumber вытягивается по высоте.\n  //  последствия пока не проверялись\n}\n.spin {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 0.5rem;\n}\n.error {\n  color: red;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__box--YuUGi`,
	"spin": `src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__spin--M6HPG`,
	"error": `src-components-Sheet2-components-CellInternalBox-CellInternalBox-module__error--v811L`
};
export default ___CSS_LOADER_EXPORT___;
